
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import bus from '@/javascript/bus'

export default {
components: {
Tab,
TabItem,
Actionsheet,
Cpts020
},
data() {
return {
minHeight: '',
mapHeight: '',
padTop: '',
tabItems: [],
days: [],
tabIndex: 2,
isTop: false,
Whether: false,
leftLayer: false,
rightLayer: true,
actIndex: -1,
markerdata: [],
changPoint: [],
aPoint: false,
theLine: true,
dayList: {},
userId: bus.userInfo.user.id,
senId: ''
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
this.$http.get('api/wtcp-recommend/public/travelPlan/app/' + this.senId + '/' + this.userId).then((res) => {
this.dayList = res.data.data
const data = res.data.data.planDetail.dailyPlans
for (let i = 0; i < data.length; i++) {
let n = []
data[i].dailySteps.map(item => {
n.push(i + 1)
item.days = n
})
}
this.markerdata = data
}).then(() => {
document.title = this.dayList.title
this.allFun(this.markerdata)
for (let i = 0; i < this.markerdata.length; i++) {
this.days.push('第' + (i + 1) + '天')
}
this.mapHeight = this.$refs.mapTop.clientHeight - 1
})
},

methods: {
formatDuring(s) {
let t;
if (s > -1) {
const hour = Math.floor(s / 3600);
const min = Math.floor(s / 60) % 60;
if (hour > 0) {
t = hour + "h";
} else {
t = "";
}
t += min + "m";
}
return t;
},
allPoint() {
this.aPoint = false
this.actIndex = -1,
this.allFun(this.markerdata)
},

toggle(index) {
this.actIndex = index
this.aPoint = true
this.theLine = true
let arr = []
arr.push(this.markerdata[index])
this.marFun(arr)
},

allFun(em) {
const map = new AMap.Map("mapBox", {
resizeEnable: true
});
map.clearMap();
let icon
const markers = [],
allPoint = []
for (let i = 0, arr = []; i < em.length; i++) {
for (let j = 0; j < em[i].dailySteps.length; j++) {
let flag = false
for (let n = 0; n < arr.length; n++) {
if (arr[n].endAddress === em[i].dailySteps[j].endAddress) {
const days = []
flag = true
if (i < j) {
days.push(i + 1, j + 1)
} else if (i === j) {
days.push(i + 1)
} else if (i > j) {
days.push(j + 1, i + 1)
}
arr[n].days = days
}
}
if (!flag) {
arr[arr.length] = em[i].dailySteps[j];
}
}
allPoint.push(arr)
}
const _this = this
for (let i = 0; i < allPoint[0].length; i++) {
let content

const pointFun = function (data, icon) {
if (data[i].days.length > 1 && data[i].days[0] !== data[i].days[1]) {
content = '<div class="markInfo">' +
'<div class="box">' +
'<div class="pic"><img src="' + icon + '"/></div>' +
'<p>' +
'<span>' + data[i].endAddress + '</span>' +
'<em>Day ' + data[i].days[0] + '·' + data[i].days[1] + '</em>' +
'</p>' +
'</div>' +
'</div>'
} else if (data[i].days.length > 1 && data[i].days[0] === data[i].days[1]) {
content = '<div class="markInfo">' +
'<div class="box">' +
'<div class="pic"><img src="' + icon + '"/></div>' +
'<p>' +
'<span>' + data[i].endAddress + '</span>' +
'<em>Day ' + data[i].days[0] + '</em>' +
'</p>' +
'</div>' +
'</div>'
} else if (data[i].days.length === 1) {
content = '<div class="markInfo">' +
'<div class="box">' +
'<div class="pic"><img src="' + icon + '"/></div>' +
'<p>' +
'<span>' + data[i].endAddress + '</span>' +
'<em>Day ' + data[i].days[0] + '</em>' +
'</p>' +
'</div>' +
'</div>'
}
const marker = new AMap.Marker({
position: new AMap.LngLat(data[i].endLongitude, data[i].endLatitude),
content: content
});
markers.push(marker);
map.setFitView()

const overlayGroups = new AMap.OverlayGroup(markers);

map.add(overlayGroups);
AMap.event.addListener(marker, 'click', function () {
_this.theLine = true
_this.aPoint = true
if (data[i].days) {
_this.actIndex = data[i].days[0] - 1
let arr = []
arr.push(_this.markerdata[data[i].days[0] - 1])
_this.marFun(arr)
} else {
_this.actIndex = i
let arr = []
arr.push(_this.markerdata[i])
_this.marFun(arr)
}
});
}


if (allPoint[0][i].stepType === 3) {
icon = require('../../../../assets/map-place.png')
pointFun(allPoint[0], icon)
} else {
icon = require('../../../../assets/map-view.png')
pointFun(allPoint[0], icon)
}
}

},

marFun(em) {
const map = new AMap.Map("mapBox", {
resizeEnable: true,
});
const markers = [];
for (let i = 0; i < em.length; i++) {
for (let j = 0; j < em[i].dailySteps.length; j++) {
const lineData = new Array()
const url = this.PIC_BASE_URL
const lnglats = em[i].dailySteps;
for (let i = 0; i < lnglats.length; i++) {
lineData[i] = [lnglats[i].endLongitude, lnglats[i].endLatitude]
const marker = new AMap.Marker({
position: new AMap.LngLat(lnglats[i].endLongitude, lnglats[i].endLatitude),
offset: new AMap.Pixel(-14, -11),
content: '<div class="marPoint">' +
'<span><em>' + (i + 1) + '</em></span>' +
'</div>',
});
markers.push(marker);

if (lnglats[i].stepType === 9) {
const time = (lnglats[i].useTime / 3600).toFixed(2)
const infoWindow = new AMap.InfoWindow({
isCustom: true,  //使用自定义窗体
content: '<div class="infow-window">' +
'<h1>' + lnglats[i].endAddress + '</h1>' +
'<a href="/webapp/#/scenic-view/'+lnglats[i].scenicId+'"><i style="background-image: url(' + url + '/' + lnglats[i].titleImage + '); "></i></a>' +
'<p>建议游玩时间：' + time + '小时</p>' +
'</div>',
offset: new AMap.Pixel(0, -12)
});
AMap.event.addListener(marker, 'click', function () {
infoWindow.open(map, marker.getPosition());
});
} else if (lnglats[i].stepType === 3 || lnglats[i].stepType === 4 || lnglats[i].stepType === 1) {   //机场车站地区无游玩时间
const infoWindow = new AMap.InfoWindow({
isCustom: true,  //使用自定义窗体
content: '<div class="infow-window">' +
'<h1>' + lnglats[i].endAddress + '</h1>' +
'</div>',
offset: new AMap.Pixel(0, -12)
});
AMap.event.addListener(marker, 'click', function () {
infoWindow.open(map, marker.getPosition());
});
} else {
const time = (lnglats[i].useTime / 3600).toFixed(2)
const infoWindow = new AMap.InfoWindow({
isCustom: true,  //使用自定义窗体
content: '<div class="infow-window">' +
'<h1>' + lnglats[i].endAddress + '</h1>' +
'<p>建议游玩时间：' + time + '小时</p>' +
'</div>',
offset: new AMap.Pixel(0, -12)
});
AMap.event.addListener(marker, 'click', function () {
infoWindow.open(map, marker.getPosition());
});
}
}
map.setFitView();
if (lineData.length > 0) {
const polyline = new AMap.Polyline({
path: lineData,            // 设置线覆盖物路径
strokeColor: '#ccc',       // 线颜色
strokeOpacity: 1,         // 线透明度
strokeWeight: 2,          // 线宽
strokeStyle: 'solid',     // 线样式
strokeDasharray: [0, 5],  // 补充线样式
geodesic: true            
});
polyline.setMap(map)
map.setFitView();
}

const overlayGroups = new AMap.OverlayGroup(markers);

map.add(overlayGroups);
}
}
},


tabHandler: function (index) {
this.$router.replace({path: this.tabItems[index].routerLink + this.senId})
}
},
created() {
this.senId = this.$route.params.id
this.tabItems = [{
name: '概要',
routerLink: '/travel-profile/'
}, {
name: '详情',
routerLink: '/travel-details/0/',
}, {
name: '地图',
routerLink: '/map-days/'
},




]
}
}
